import * as organizationsAccessTokensCommands from '@Organizations/AccessTokens/commands-vue-composables'
import * as organizationsAccessTokensQueries from '@Organizations/AccessTokens/queries-vue-composables'
import * as organizationsUsersQueries from '@Organizations/Users/queries-vue-composables'

export function useMyAccessTokensPage(){
	return {
		useCurrentUserQuery: organizationsUsersQueries.useCurrentUserQueryV1,
		useGenerateAccessTokenCommand: organizationsAccessTokensCommands.useGenerateAccessTokenCommandV1,
		useRevokeAccessTokenCommand: organizationsAccessTokensCommands.useRevokeAccessTokenCommandV1,
		useUserAccessTokensQuery: organizationsAccessTokensQueries.useUserAccessTokensQueryV1,
	}
}

